import React, { useEffect } from 'react';
import dayjs from 'dayjs';
import { Button, Calendar, Col, DatePicker, Row, Space } from 'antd';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import PreferenceList from './preference_list';
import { ArrowLeftOutlined, CaretDownFilled, CloseCircleFilled, LeftOutlined, RightOutlined } from '@ant-design/icons';
import { set_purchase_detail } from '../../../actions/purchase.action';
import event_visit_dates from '../../../config/event.config';

const is_schoolbreak = process.env.REACT_APP_EVENT_CODE === 'SCHOOLBREAK';

const PurchaseTicketDatePicker = ({ changeDate, park, is_screen, defaultValue, }) => {
    const dispatch = useDispatch();
    const purchaseRedux = useSelector(state => state?.purchase);
    const ticketRedux = useSelector(state => state?.ticket);
    const ticket_type = park?.ticket_types?.find(x => x?.ticket_type_id == purchaseRedux?.ticket_type_id);
    const disabledDate = (current) => {
        const park_applicable_ticket_type = ticket_type?.ParkApplicableTicketType;
        const advance_day = park_applicable_ticket_type?.advance_day;
        const date_range = park_applicable_ticket_type?.date_range;
        const custom_format = "YYYY-MM-DD";
        let custom_date = moment().format(custom_format);
        const previous_date = current < moment(custom_date, custom_format);

        // get all maintenance date
        const maintenances = park?.maintenance_frequencies ?? [];
        let date_range_arr = [];
        let frequence_disabled = false;

        for (const maintenance of maintenances) {
            const start_date = maintenance?.ParkMaintenance?.start_date;
            const end_date = maintenance?.ParkMaintenance?.end_date;
            const maintenance_frequency =
                maintenance?.code === "DL"
                    ? current.format(maintenance?.format)
                    : moment(start_date)?.format(maintenance?.format);

            if (end_date) {
                if (
                    current.format(custom_format) >=
                        moment(start_date).format(custom_format) &&
                    current.format(custom_format) <=
                        moment(end_date).format(custom_format)
                ) {
                    frequence_disabled =
                        current.format(maintenance?.format) == maintenance_frequency;
                }
            } else {
                if (current.format(custom_format) >= moment(start_date).format(custom_format)) {
                    frequence_disabled =
                        current.format(maintenance?.format) == maintenance_frequency;
                }
            }

            // if date range, then previous date also need to disable
            if (date_range) {
                let date_range_disable_arr = [];
                for (let i = 1; i <= date_range; i++) {
                    const current_add_date_range = current
                        ?.clone()
                        .add(i, "days")
                        .format(maintenance?.format);
                    const is_within_maintainence_date =
                        current_add_date_range == maintenance_frequency;
                    date_range_disable_arr.push(is_within_maintainence_date);
                }

                const is_disabled = date_range_disable_arr?.find((x) => x == true) ?? false;
                date_range_arr?.push(is_disabled);
            }
        }
        const date_range_disabled = date_range_arr?.find((x) => x === true) ?? false;

        let is_advance_day = false;
        if (!ticketRedux?.special_link) {
            if (advance_day) {
                const disable_end = moment(custom_date)
                    ?.add(advance_day, "days")
                    ?.format(custom_format);
                const today = current.format(custom_format);
                const is_between_disable = moment(today)?.isBetween(
                    custom_date,
                    disable_end,
                    undefined,
                    "[)"
                );
                is_advance_day = is_between_disable;
            }
        }

        // ✅ Cut-off time rule
        let is_cutoff = false;
        if (park?.ticket_cut_off_time) {
            const now = moment();
            if (current.isSame(now, "day")) {
                const cutoffToday = moment(now.format("YYYY-MM-DD") + " " + park.ticket_cut_off_time, "YYYY-MM-DD HH:mm:ss");
                if (now.isAfter(cutoffToday)) {
                    is_cutoff = true;
                }
            }
        }

        const disabled =
            date_range_disabled || frequence_disabled || is_advance_day || previous_date || (!is_schoolbreak && is_cutoff);
        return disabled;
    };

    // schoolbreak: hardcode visit date per ticket type (see src/config/event.config.js)
    useEffect(() => {
        if(!is_schoolbreak) return;
        const hardcoded_date = event_visit_dates[purchaseRedux?.ticket_type_id];
        if(hardcoded_date){
            dispatch(set_purchase_detail({
                visit_date : dayjs(hardcoded_date)?.format("DD/MM/YYYY"),
            }))
        }
    }, [purchaseRedux?.ticket_type_id])

    return (
        <>
            {
                is_screen ?
                (
                    <>
                        <Calendar
                        headerRender={({ value, type, onChange, onTypeChange, }) => {
                            const date_item = dayjs(value);
                            const cur_month = date_item?.month();
                            const month_name = date_item?.format("MMM");
                            const year_name = date_item?.format("YYYY");

                            return (
                                <>
                                    <div style={{width : '100%', padding : '12px 0',}}>
                                        <Row align='middle'>
                                            <Col span={4} style={{textAlign:'center',}}>
                                                <Button
                                                onClick={() => {
                                                    // go to next month
                                                    const now = value.clone()?.month(cur_month - 1);
                                                    onChange(now);
                                                }}
                                                type='text'
                                                icon={<LeftOutlined style={{color : 'var(--secondary-text-color)'}} />}
                                                />
                                            </Col>
                                            <Col span={16}>
                                                <div style={{textAlign:'center',}}>
                                                    <span style={{fontSize:16, fontWeight:500,}}>{`${month_name} ${year_name}`}</span>
                                                </div>
                                            </Col>
                                            <Col span={4} style={{textAlign:'center',}}>
                                                <Button
                                                onClick={() => {
                                                    // go to next month
                                                    const now = value.clone()?.month(cur_month + 1);
                                                    onChange(now);
                                                }}
                                                type='text'
                                                icon={<RightOutlined style={{color : 'var(--secondary-text-color)'}} />}
                                                />
                                            </Col>
                                        </Row>
                                    </div>
                                </>
                            )
                        }}
                        fullscreen={false}
                        disabledDate={disabledDate}
                        mode='month'
                        onChange={(v, ds) => changeDate(v)}
                        defaultValue={defaultValue}
                        // value={null}
                        />
                    </>
                )
                :
                (
                    <>
                        {
                            is_schoolbreak ? (
                                <span className='purchase-visit-date'>
                                    {purchaseRedux?.visit_date}
                                </span>
                            ) : (
                                <DatePicker
                                format={'DD/MM/YYYY'}
                                inputReadOnly
                                disabledDate={disabledDate}
                                variant='borderless'
                                onChange={(v, ds) => changeDate(ds)}
                                value={purchaseRedux?.visit_date && dayjs(purchaseRedux?.visit_date, 'DD/MM/YYYY')}
                                className='purchase-visit-date'
                                popupClassName='purchase-visit-date-dropdown'
                                size={'large'}
                                suffixIcon={(<CaretDownFilled style={{color:'var(--main-color)', fontSize:18, fontWeight:'bold'}} />) }
                                allowClear={false}
                                showTime={false}
                                />
                            )
                        }
                    </>
                )
            }
        </>
    );
}

export default PurchaseTicketDatePicker;
